import React from 'react';
import { BRAND_NAME } from '../../config/brand';
import { cardTheme } from '../../styles/cardTheme';

const HOME_ITEMS = [
  {
    src: '/img/home-items/1.svg',
    title: 'منهج شامل',
    description: 'باقات مراجعة بتساعدك تتقن المنهج في مدة قصيرة',
  },
  {
    src: '/img/home-items/2.svg',
    title: 'جودة عالية',
    description: 'محتوى تعليمي يليق بتميز الطالب الأزهري',
  },
  {
    src: '/img/home-items/3.svg',
    title: 'مدرسين خبراء',
    description: 'خبرة أكثر من عشر سنوات مع طلاب الثانوية الأزهرية',
  },
  {
    src: '/img/home-items/4.svg',
    title: 'تعلم في أي وقت',
    description: 'شوف الدروس من موبايلك أو لابتوبك وقت ما تحب',
  },
  {
    src: '/img/home-items/5.svg',
    title: 'مراجعات وامتحانات',
    description: 'أسئلة ومراجعات شاملة تجهزك للامتحان بثقة',
  },
  {
    src: '/img/home-items/6.svg',
    title: 'دعم مستمر',
    description: 'فريق دعم ومجتمع طلابي معاك طول الرحلة',
  },
];

const WhyChooseBanner: React.FC = () => (
  <section id="why-choose-section" className="scroll-mt-24 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="mb-10 max-w-2xl sm:mb-14">
        <div className="mb-3 flex items-center gap-2.5">
          <span className="inline-block h-5 w-1 shrink-0 rounded-full bg-gold-500" aria-hidden />
          <p className="text-sm font-semibold text-gold-700">لماذا نحن؟</p>
        </div>
        <h2 className={`text-[clamp(1.75rem,3.5vw,3rem)] font-bold leading-tight ${cardTheme.title}`}>
          ليه {BRAND_NAME} أفضل اختيار ليك؟
        </h2>
        <p className="mt-3 max-w-xl text-sm leading-relaxed text-green-900/70 sm:text-base">
          من الشرح للمراجعة للدعم: المنصة مبنية على احتياج طالب الثانوية الأزهرية
        </p>
      </div>

      <div className="grid grid-cols-1 gap-x-12 gap-y-10 md:grid-cols-2">
        {HOME_ITEMS.map((item, index) => (
          <article key={item.src} className="flex items-start gap-4 sm:gap-5">
            <span
              className="w-12 shrink-0 font-thmanyah text-3xl tabular-nums leading-none text-gold-500/80 sm:w-14 sm:text-4xl"
              aria-hidden
            >
              {String(index + 1).padStart(2, '0')}
            </span>
            <div className="min-w-0 flex-1 border-t border-gold-500/25 pt-3">
              <div className="mb-2 flex items-center gap-3">
                <img
                  src={item.src}
                  alt=""
                  className="h-10 w-10 object-contain sm:h-12 sm:w-12"
                  loading="lazy"
                />
                <h3 className={`text-base font-bold sm:text-lg ${cardTheme.title}`}>{item.title}</h3>
              </div>
              <p className="text-sm leading-relaxed text-green-900/70 sm:text-[0.95rem] sm:leading-7">
                {item.description}
              </p>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseBanner;
